import { GatsbyBrowser } from 'gatsby';

const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = () => false;

const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  if (typeof window !== 'undefined') {
    const path = location.pathname;
    if (!path.includes('careers/') || path.includes('careers/team/')) {
      window.scroll(0, 0);
    }
  }

  if (window.optimizely) {
    try {
      window.optimizely.push({
        type: 'activate'
      });
    } catch (error) {
      console.error('Unable to report to Optimizely on route change.', error);
    }
  }
};

export {
  onRouteUpdate,
  shouldUpdateScroll
};
